/* eslint-disable max-lines */
import { IconComponent, ShieldCheckIcon, SpeakerSlashIcon, ThermometerIcon } from '@fronton/icons-react';
import { WINDOWS_CDN_PATH } from '../../windows-constants';

export type BrandInfo = {
  imgSrc: string;
  name: string;
  type: string;
  properties: {
    Icon: IconComponent,
    text: string;
  }[];
}

export const WINDOWS_BRAND_BANNER_INFO_MAP = {
  deceuninck: 'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Deceuninck_partner_certificate_Leroy_Merlin.pdf',
  rehau: 'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Rehau_partner_certificate_Leroy_Merlin.pdf',
  veka: 'https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/windows/Veka_partner_certificate_Leroy_Merlin.pdf',
}

export const WINDOWS_BRAND_TITLE_MAP = {
  deceuninck: 'Окна бренда Deceuninck',
  rehau: 'Окна бренда Рехау',
  veka: 'Окна бренда Veka',
};

export const DECEUNINCK_BRAND_INFO = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/b/forward.jpg/forward.jpg`,
    name: 'Forward',
    type: 'Минимальный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -10°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'тихая городская\nулица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/b/favorit-platinum.jpg/favorit-platinum.jpg`,
    name: 'Favorit Platinum',
    type: 'Стандартный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'улица со спокойным\nтрафиком',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/b/bautec-urban.jpg/bautec-urban.jpg`,
    name: 'Bautec Urban',
    type: 'Комфорт',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nгородская улица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/deceuninck/b/favorit-space.jpg/favorit-space-04.jpg`,
    name: 'Favorit Space',
    type: 'Премиум',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nавтомагистраль',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
];

export const REHAU_BRAND_INFO = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/b/blitz.jpg/blitz.jpg`,
    name: 'Blitz',
    type: 'Минимальный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -10°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'тихая городская\nулица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/b/delight-design.jpg/delight-design.jpg`,
    name: 'DELIGHT-Design',
    type: 'Стандартный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'улица со спокойным\nтрафиком',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/b/grazio.jpg/grazio.jpg`,
    name: 'GRAZIO',
    type: 'Комфорт',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nгородская улица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/b/intelio.jpg/intelio.jpg`,
    name: 'INTELIO',
    type: 'Премиум',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nавтомагистраль',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
];

export const VEKA_BRAND_INFO = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/b/whs_60.jpg/whs_60.jpg`,
    name: 'WHS 60 by VEKA',
    type: 'Минимальный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -10°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'тихая городская\nулица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/b/whs_72.jpg/whs_72.jpg`,
    name: 'WHS 72 by VEKA',
    type: 'Стандартный',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'улица со спокойным\nтрафиком',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/b/softline_70.jpg/softline_70.jpg`,
    name: 'VEKA Softline 70',
    type: 'Комфорт',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nгородская улица',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/brands/veka/b/softline_82.jpg/softline_82.jpg`,
    name: 'VEKA Softline 82',
    type: 'Премиум',
    properties: [
      {
        Icon: ThermometerIcon,
        text: 'до -20°C и ниже',
      },
      {
        Icon: SpeakerSlashIcon,
        text: 'оживлённая\nавтомагистраль',
      },
      {
        Icon: ShieldCheckIcon,
        text: 'гарантия от 3 лет',
      },
    ],
  },
];

export const BRAND_INFO_MAP: Record<string, BrandInfo[]> = {
  deceuninck: DECEUNINCK_BRAND_INFO,
  rehau: REHAU_BRAND_INFO,
  veka: VEKA_BRAND_INFO,
};
